// @ts-ignore
// https://mcdatepicker.netlify.app/docs/methods
// https://www.cssscript.com/mc-datepicker/
import MCDatepicker from 'mc-datepicker';

export default function () {
  // Filter date start
  const datepickerFilterDateStart = MCDatepicker.create({
    el: '#filter--date-start',
    bodyType: 'inline',
    dateFormat: 'dd.mm.yyyy',
    minDate: new Date(),
    autoClose: true,
    closeOnBlur: true,
    firstWeekday: 1,
    customCancelBTN: 'Abbrechen',
    customClearBTN: 'Löschen',
    customWeekDays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    theme: {
      theme_color: '#ec6607',
      main_background: '#ffffff',
      picker: {
        foreground: '#757575',
        background: '#fafafa'
      },
      date: {
        active: {
          default: {
            foreground: '#757575',
          },
          picked: {
            foreground: '#ffffff',
            background: '#ec6607'
          },
          today: {
            foreground: '#ffffff',
            background: '#0d8898'
          }
        },
        inactive: {
          default: {
            foreground: '#757575'
          },
          picked: {
            foreground: '#ffffff',
            background: '#ec6607'
          },
          today: {
            foreground: '#0d8898',
            background: '#ffffff'
          }
        },
        marcked: {
          foreground: '#38ada9'
        }
      },
    },
  });

  datepickerFilterDateStart.onSelect((date: string) => {
    const parsedDate = new Date(date);
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    const event = new Event('input', { bubbles: true });
    const input = document.querySelector('#filter--date-start') as HTMLInputElement;
    input.value = formattedDate;
    input.dispatchEvent(event);
  });

  // Filter date end
  const datepickerFilterDateEnd = MCDatepicker.create({
    el: '#filter--date-end',
    bodyType: 'inline',
    dateFormat: 'dd.mm.yyyy',
    minDate: new Date(),
    autoClose: true,
    closeOnBlur: true,
    firstWeekday: 1,
    customCancelBTN: 'Abbrechen',
    customClearBTN: 'Löschen',
    customWeekDays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    theme: {
      theme_color: '#ec6607',
      main_background: '#ffffff',
      picker: {
        foreground: '#757575',
        background: '#fafafa'
      },
      date: {
        active: {
          default: {
            foreground: '#757575',
          },
          picked: {
            foreground: '#ffffff',
            background: '#ec6607'
          },
          today: {
            foreground: '#ffffff',
            background: '#0d8898'
          }
        },
        inactive: {
          default: {
            foreground: '#757575'
          },
          picked: {
            foreground: '#ffffff',
            background: '#ec6607'
          },
          today: {
            foreground: '#0d8898',
            background: '#ffffff'
          }
        },
        marcked: {
          foreground: '#38ada9'
        }
      },
    },
  });

  datepickerFilterDateEnd.onSelect((date: string) => {
    const parsedDate = new Date(date);
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    const event = new Event('input', { bubbles: true });
    const input = document.querySelector('#filter--date-end') as HTMLInputElement;
    input.value = formattedDate;
    input.dispatchEvent(event);
  });
}
